import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M9.333 15.333H6.667A.667.667 0 0 1 6 14.667V1.333a.667.667 0 0 1 .667-.666h2.666a.666.666 0 0 1 .667.666v13.334a.667.667 0 0 1-.667.666M4 15.333H1.333a.667.667 0 0 1-.666-.666V9.333a.667.667 0 0 1 .666-.666H4a.666.666 0 0 1 .667.666v5.334a.667.667 0 0 1-.667.666M12 15.333h2.667a.665.665 0 0 0 .666-.666v-8A.667.667 0 0 0 14.667 6H12a.667.667 0 0 0-.667.667v8a.667.667 0 0 0 .667.666"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })